/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Ivory_Crane_NoteInputs */

const en_wild_ivory_crane_note = /** @type {(inputs: Wild_Ivory_Crane_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about user import`)
};

const de_wild_ivory_crane_note = /** @type {(inputs: Wild_Ivory_Crane_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr über den Benutzerimport`)
};

/**
* | output |
* | --- |
* | "Learn more about user import" |
*
* @param {Wild_Ivory_Crane_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_ivory_crane_note = /** @type {((inputs?: Wild_Ivory_Crane_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Ivory_Crane_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_ivory_crane_note(inputs)
	return de_wild_ivory_crane_note(inputs)
});